import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
//import * as Pusher from 'pusher-js';
const Pusher = require('pusher-js');
import * as PusherTypes from 'pusher-js';
import { Subject } from 'rxjs';
import { GlobalWindow } from '../main.window';

declare let window: GlobalWindow;

var presenceChannel: PusherTypes.PresenceChannel;

// ------------------------------------------------------
@Injectable()
export class PusherService {
  private notifications$: Subject<any> = new Subject<any>();
  private spreadsheetpreview$: Subject<any> = new Subject<any>();

  pusher: any = null;
  channel: Pusher.Channel = null;
  notification_channel: Pusher.Channel = null;
  spreadsheet_preview_channel: Pusher.Channel = null;

  // ------------------------------------------------------
  constructor(private http: HttpClient) {
    this.pusher = new Pusher('17a808f7c974a0c362e3', {
      cluster: 'mt1',
      encrypted: true,
      authEndpoint: window.pusherEndPoint,
    });
  }

  // ------------------------------------------------------
  public listenAccount(accountId: string) {
    if (this.channel) {
      this.pusher.unsubscribe(this.channel.name);
    }

    this.channel = this.pusher.subscribe(
      'private-' + window.env + '-account-' + accountId,
    );

    if (this.notification_channel) {
      this.notification_channel.unbind();
    }
    this.notification_channel = this.channel.bind('notification', data => {
      console.warn('Pusher');
      console.warn(data);
      this.notifications$.next(data);
    });

    if (this.spreadsheet_preview_channel) {
      this.spreadsheet_preview_channel.unbind();
    }
    this.spreadsheet_preview_channel = this.channel.bind(
      'spreadsheet-preview',
      data => {
        this.spreadsheetpreview$.next(data);
      },
    );
  }

  // ------------------------------------------------------
  spreadsheetPreview() {
    return this.spreadsheetpreview$;
  }

  // ------------------------------------------------------
  notifications() {
    return this.notifications$;
  }
}
